import { carPageListEN } from "@api/siteConfig";
import { loginOut, userInfo } from "@/services/login";
import { List, menuList } from "./dict";
import CollapseTransition from "@/components/CollapseTransition/index.vue";
import SvgIcon from "@/components/Icon/index.vue";
import Drawer from "@/components/Drawer/index.vue";
import utils from "@utils";

export default {
  name: "Header",
  props: {
    fixed: Boolean,
    headerClass: String,
    models: {
      type: String,
      default: "",
    },
  },
  components: {
    CollapseTransition,
    SvgIcon,
    Drawer,
  },

  data() {
    const isDev = process.env.NODE_ENV === "development";
    return {
      visible: false,
      navigationList: {},
      menuList,
      login: false,
      scrollHandle: null,
      defaultEl: null,
      userInfo: {},
      modelsValue: {
        z03: "13.48",
        a06: "17.98",
        "007": "29.98",
        v09: "31.88",
        a06plus: "13.98",
      },
      parameterTypeValue: {
        z03: "Z03",
        a06: "A06",
        "007": "007",
        v09: "V09",
        a06plus: "A06PLUS",
      },
      modelsStatus: true,
      menu: [],
      isLanguageBoxOpen: false,
      isScroll: false,
      openNav: false,
      hovering: false,
      hoverType: "",
    };
  },
  computed: {
    showHovering() {
      return (
        // !["user", "language"].includes(this.hoverType) &&
        this.hovering || this.openNav
      );
    },
    menuFlat() {
      let arr = [];
      this.menu.forEach((element) => {
        if (element.childrens && element.childrens.length) {
          element.childrens.forEach((v) => arr.push(v));
        } else {
          arr.push(element);
        }
      });
      return arr;
    },
  },
  async mounted() {
    if (this.fixed || this.headerClass === "white") {
      this.ininScroll();
    }

    await carPageListEN({}).then((res) => {
      const dataList = res.data.map((item) => {
        if (process.env.NODE_ENV === "development") {
          item.pageUrl = item.pageUrl.replace(
            "https://www-test.gac-nio.com",
            window.location.origin
          );
        }
        return {
          label: item.name,
          type: utils.removeSpacesAndConvertToUpper(item.name),
          url: item.pageUrl,
          value: item.id,
          tabType: item.tabType,
        };
      });
      this.navigationList = this.updateListUrls(List, res.data || []);
      this.menu = dataList;
    });
  },
  unMounted() {
    this.removeScroll();
  },
  methods: {
    goParameter() {
      console.log(this.models);
      window.location.href = `./params-table-config.html?type=${
        this.parameterTypeValue[this.models]
      }`;
    },
    updateListUrls(list, arr) {
      for (const key in list) {
        const item = list[key];
        const exploreItem = item.imgList.find(
          (imgItem) => imgItem.desc === "Explore"
        );
        if (exploreItem) {
          const matchingArrItem = arr.find(
            (arrItem) =>
              utils.removeSpacesAndConvertToUpper(arrItem.name) ===
              utils.removeSpacesAndConvertToUpper(item.name)
          );
          if (matchingArrItem) {
            exploreItem.url = matchingArrItem.pageUrl;
          }
        }
      }
      console.log(list);
      return list;
    },
    clickMenuItem(item) {
      if (item.type === "loginOut") {
        this.loginOut();
      } else {
        window.location.href = item.url;
      }
    },
    async loginOut() {
      await loginOut();
      localStorage.removeItem("accessToken");
      localStorage.removeItem("userInfo");
      localStorage.removeItem("needAuth");
      this.login = false;
      window.location.href = "./login.html";
    },
    getUserInfo() {
      userInfo().then((data) => {
        // const { userId, username, avatar } = data.data;
        this.userInfo = data.data;
        localStorage.setItem("userInfo", JSON.stringify(data.data));
      });
    },
    goOrder() {
      window.location.href = "/test-order.html";
    },
    /**
     * 添加滚动监听
     */
    ininScroll() {
      this.scrollHandle = (ev) => {
        let el =
          ev.target.scrollingElement || ev.target.documentElement || ev.target;
        let top = el.scrollTop;
        if (top <= 1) {
          this.isScroll = false; //导航栏变透明
          if (
            this.models === "a06" ||
            this.models === "v09" ||
            this.models === "z03" ||
            this.models === "007" ||
            this.models === "a06plus"
          ) {
            this.modelsStatus = true;
          }
        }
        if (top <= 1 && this.headerClass === "white") {
          this.isScroll = false;
        }
        if (this.isScroll && top > 1) return;
        // 白栏不管，滚动就变黑
        if (top > 1 && this.headerClass === "white") {
          this.isScroll = true; //导航栏变黑
        }
        if (top > 1) {
          this.isScroll = true; //导航栏变黑
          if (
            this.models === "a06" ||
            this.models === "v09" ||
            this.models === "z03" ||
            this.models === "007" ||
            this.models === "a06plus"
          ) {
            this.modelsStatus = false;
          }
        }
      };
      window.addEventListener("scroll", this.scrollHandle);
    },
    /**
     * 回收滚动事件
     */
    removeScroll() {
      window.removeEventListener("scroll", this.scrollHandlee);
    },
    /**
     * 初始化导航栏滑动块
     * @param {*} path 路径
     */
    initSlider(path, search) {
      if (path === "/" || path === "") {
        //兼容index
        path = "/index.html";
      }
      let key = path.replace(/\/([^/]+).html/g, "$1");
      try {
        let els = document.querySelectorAll(`.nav-item`);
        let index;
        if (key !== "public-page") {
          index = this.menu.findIndex((v) => v.value.split("|").includes(key));
        } else {
          let id = search.split("=")[1];
          index = this.menu.findIndex((v) => v.value === id);
        }
        if (index !== -1) {
          this.defaultEl = els[index];
          this.setSlider(this.defaultEl, true);
        } else {
          this.hideSlider();
        }
      } catch (error) {
        console.log(error);
        this.setSlider(null, true);
      }
    },
    /**
     * 执行滑块动画
     * @param {*} el 目标元素
     * @param {*} noAni 是否有动画
     * @returns
     */
    setSlider(el, noAni) {
      if (!el) {
        this.hideSlider();
        return;
      }
      let elLeft = el.offsetLeft;
      let elWidth = el.clientWidth;
      let slider = this.$refs.slider;
      let sliderWidth = el.clientWidth - 40;
      let aniText =
        "transition: transform 260ms cubic-bezier(0.33, 1, 0.68, 1), width 200ms cubic-bezier(0.33, 1, 0.68, 1);";
      if (noAni) {
        aniText = "";
      }
      let left = elLeft + (elWidth - sliderWidth) / 2;
      if (left > 0) {
        slider.style.cssText = `width:${sliderWidth}px;transform:translateX(${left}px);${aniText}`;
      }
    },

    hideSlider() {
      let slider = this.$refs.slider;
      slider.style.cssText = "visibility:hidden";
    },
    /**
     * 鼠标hover到导航栏事件
     * @param {*} ev
     */
    handleMouseEnter(ev, item) {
      // this.setSlider(ev.target);
      // 车系才显示下拉框
      this.hovering = true;
      this.hoverType = item.type;
      console.log(this.hoverType);
    },
    hoverItem(type) {
      this.hovering = true;
      this.hoverType = type;
    },
    /**
     * 鼠标离开导航栏事件
     * @param {*} ev
     */
    handleMouseLeave() {
      this.hovering = false;
      // this.setSlider(this.defaultEl);
    },
    goTest() {
      window.location.href = `./drive.html?type=${this.parameterTypeValue[
        this.models
      ] || "V09"}`;
    },
    goOptional() {
      window.location.href = `./optional.html?type=${
        this.parameterTypeValue[this.models]
      }`;
    },
    getLogin() {
      window.location.href = "./login.html";
    },
    openNavFunc() {
      this.openNav = !this.openNav;
      let el = document.scrollingElement || document.documentElement;
      if (this.openNav) {
        el.style.cssText = "overflow:hidden;";
      } else {
        el.style.cssText = "";
      }
    },
    openLanguageBox() {
      this.isLanguageBoxOpen = !this.isLanguageBoxOpen;
    },
    toggleAccordion(index) {
      this.menu.forEach((item, i) => {
        if (i === index) {
          item.isOpen = !item.isOpen;
        } else {
          item.isOpen = false;
        }
      });
      this.$forceUpdate();
    },
  },
};
